import React from 'react';
import { Monitor, ShoppingCart, Clock, AlertCircle } from 'lucide-react';
interface Package {
  name: string;
  hours: number;
  price: string;
  detailsLink?: string;
}
interface SingleClass {
  name: string;
  creditType: string;
  hours: number;
  description: string;
  price: string;
  moreLink?: string;
}
const packages: Package[] = [{
  name: '3-Class Renewal Package (select your own courses-9 hours)',
  hours: 9,
  price: '$49.95'
}, {
  name: '3-Class Broker Management Clinic (Preset with BMC 1-2-3 for 9 hours',
  hours: 9,
  price: '$54.95',
  detailsLink: '#'
}, {
  name: '3-Class Property Management BMC (Preset with BMC 1-2-3B for 9 hours)',
  hours: 9,
  price: '$54.95',
  detailsLink: '#'
}, {
  name: '6-Class Salesperson Renewal Package (select your own courses-18 hours)',
  hours: 18,
  price: '$69.95'
}, {
  name: '6-Class FIRST TIME Renewal Package (Preset -18 Hours)',
  hours: 18,
  price: '$69.95',
  detailsLink: '#'
}, {
  name: '#1 8-Class Salesperson Renewal Package (Preset-24 hours)',
  hours: 24,
  price: '$89.95',
  detailsLink: '#'
}, {
  name: '#2 8-Class Salesperson Renewal Package (Preset-24 hours with NAR Ethics)',
  hours: 24,
  price: '$89.95',
  detailsLink: '#'
}, {
  name: '10-class Broker Renewal Package (Preset-30 hours with NAR Ethics)',
  hours: 30,
  price: '$104.95',
  detailsLink: '#'
}, {
  name: '10-Class Renewal Package for Property Management Brokers (Preset 30-hours with NAR Ethics and BMC #3B)',
  hours: 30,
  price: '$104.95',
  detailsLink: '#'
}];
const singleClasses: SingleClass[] = [{
  name: 'Are They Represented?',
  creditType: 'Agency Law',
  hours: 3,
  description: 'Are They Represented? (AL) This class will explore the history of agency disclosure, from sub agency',
  price: '$19.95',
  moreLink: '#'
}, {
  name: 'Mastering Agency Agreements',
  creditType: 'Agency Law',
  hours: 3,
  description: 'Mastering Agency Agreements (AL)   Objective: Class will review the way real estate agency',
  price: '$19.95',
  moreLink: '#'
}, {
  name: 'Avoid The Oops: Contract Smarts for Agents',
  creditType: 'Contract Law',
  hours: 3,
  description: 'Avoid The Oops: Contract Smarts For Agents (CL)   Review various parts of a valid, enforceable',
  price: '$19.95',
  moreLink: '#'
}, {
  name: 'What Goes Wrong in Contracts',
  creditType: 'Contract Law',
  hours: 3,
  description: 'What Goes Wrong In Contracts? (CL)   A review of the common contract issues in residential',
  price: '$19.95',
  moreLink: '#'
}, {
  name: 'No Secrets',
  creditType: 'Disclosure',
  hours: 3,
  description: 'No Secrets (DISC) A review of some of the more common disclosure issues including mold, crimes,',
  price: '$19.95',
  moreLink: '#'
}, {
  name: 'The Bottom Line of Disclosure',
  creditType: 'Disclosure',
  hours: 3,
  description: 'The Bottom Line of Disclosure (DISC)   Objective: This course will review various disclosure',
  price: '$19.95',
  moreLink: '#'
}, {
  name: 'Your Clients Are Not Mushrooms',
  creditType: 'Disclosure',
  hours: 3,
  description: 'Your Clients Are Not Mushrooms (DISC) Objective: Class will review many of the standard disclosure',
  price: '$19.95',
  moreLink: '#'
}, {
  name: "Fair Housing In Today's World",
  creditType: 'Fair Housing',
  hours: 3,
  description: "Fair Housing In Today's World (FH) This course will explore some of the historical events that",
  price: '$19.95',
  moreLink: '#'
}, {
  name: 'They Are A Protected Class',
  creditType: 'Fair Housing',
  hours: 3,
  description: 'They Are A Protected Class (FH) This is an overview of Fair Housing laws in the United States. The',
  price: '$19.95',
  moreLink: '#'
}, {
  name: 'Deeds, Fires & Water: Be Prepared',
  creditType: 'General — Deed Fraud, Firewise, AZ Water',
  hours: 3,
  description: 'Deeds, Fires & Water: Be Prepared (GEN)-NEW ADRE Class Requirement as of 2025 Our obligation',
  price: '$18.95',
  moreLink: '#'
}, {
  name: 'Accidental Property Management',
  creditType: 'Legal Issues',
  hours: 3,
  description: 'Accidental Property Management (LI) This course will explain the circumstances where a licensee',
  price: '$19.95',
  moreLink: '#'
}, {
  name: 'Follow All The Laws',
  creditType: 'Legal Issues',
  hours: 3,
  description: 'Follow All The Laws (LI)   This class will explore some statutes that affect many real',
  price: '$19.95',
  moreLink: '#'
}, {
  name: 'The Owner Is In Default',
  creditType: 'Legal Issues',
  hours: 3,
  description: 'The Owner Is In Default (LI)   This course will explore some of the areas surrounding distressed',
  price: '$19.95',
  moreLink: '#'
}, {
  name: 'A Letter From ADRE',
  creditType: "Requirements for Licensees (formerly Commissioner's Standards/Rules)",
  hours: 3,
  description: 'A Letter From ADRE (CS)   This course will review both the Arizona Revised Statutes and',
  price: '$19.95',
  moreLink: '#'
}, {
  name: 'BMC #1 AZ Residential-Statutes and Rules',
  creditType: "Requirements for Licensees (formerly Commissioner's Standards/Rules)",
  hours: 3,
  description: 'BMC#1 AZ Residential Statutes & Rules (CS) This is part 1 of the 3 required, 9 hour Broker Management',
  price: '$19.95',
  moreLink: '#'
}, {
  name: 'BMC #2 AZ Residential-Broker Policies',
  creditType: "Requirements for Licensees (formerly Commissioner's Standards/Rules)",
  hours: 3,
  description: 'BMC#2 AZ Broker Policies (CS) This is part 2 of the 3 required, 9 hour Broker Management Clinic >',
  price: '$19.95',
  moreLink: '#'
}, {
  name: 'BMC #3 AZ Residential-Broker Supervision',
  creditType: "Requirements for Licensees (formerly Commissioner's Standards/Rules)",
  hours: 3,
  description: 'BMC#3 AZ Residential Broker Supervision (CS) This is part 3 of the 3 required, 9 hour Broker Management',
  price: '$19.95',
  moreLink: '#'
}, {
  name: 'BMC #3B Property Management',
  creditType: "Requirements for Licensees (formerly Commissioner's Standards/Rules)",
  hours: 3,
  description: 'Broker Management Clinic #3B Property Management (CS)   If the broker conducts or allows PROPERTY',
  price: '$19.95',
  moreLink: '#'
}, {
  name: "Don't Lose Your License",
  creditType: "Requirements for Licensees (formerly Commissioner's Standards/Rules)",
  hours: 3,
  description: "Don't Lose Your License (CS) This class will look at various parts of the Arizona Revised Statutes",
  price: '$19.95',
  moreLink: '#'
}, {
  name: 'Ethics & The Rules (with NAR Code of Ethics)',
  creditType: "Requirements for Licensees (formerly Commissioner's Standards/Rules)",
  hours: 3,
  description: "CS CE credit + Complies with current NAR cycle January 2025-December 2027 The Commissioner's",
  price: '$19.95',
  moreLink: '#'
}, {
  name: 'NAR Code of Ethics (NO CE CREDIT)',
  creditType: 'NONE',
  hours: 0,
  description: '(No CE Credit - No Clock Hours) Complies with current cycle January 2025-December 2027 REMEMBER:SEND',
  price: '$14.95',
  moreLink: '#'
}];
export function OnlineClasses() {
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-1411" data-mp="2yvep8za3djaq">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1412" data-mp="2uv4gxfytugsp">
        {/* Page Header */}
        <div className="mb-12" data-id="element-1413" data-mp="3rcr0py8yowcs">
          <div className="flex items-center justify-center mb-6" data-id="element-1414" data-mp="3rdso9275zbbe">
            <Monitor className="w-12 h-12 text-[#fcb53d] mr-4" data-id="element-1415" data-mp="3mm26wc9t7nah" />
            <h1 className="text-4xl font-bold text-[#fcb53d]" data-id="element-1416" data-mp="3mkr7eoned1p6">
              ON-DEMAND CLASSES
            </h1>
          </div>
        </div>

        {/* Requirements Section */}
        <div className="mb-12 bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-1417" data-mp="ew6tb1bfc69k">
          <p className="text-base text-gray-900 mb-4" data-id="element-1418" data-mp="7af0mirxx0i">
            Your 24 hour requirement (every two years), includes 21 hours (7
            class types), with at least one class (3 hrs) of each of the
            following credit types:
          </p>
          <ul className="space-y-1 mb-6 ml-4" data-id="element-1419" data-mp="stbxevrkuv26">
            <li className="text-base text-gray-900" data-id="element-1420" data-mp="xt810twd4kh7">
              <strong data-id="element-1421" data-mp="xrwy0waqrgr5">*Agency Law</strong>
            </li>
            <li className="text-base text-gray-900" data-id="element-1422" data-mp="iw78wpa9eni7">
              <strong data-id="element-1423" data-mp="nvtlqxm6e1qh">*Contract Law</strong>
            </li>
            <li className="text-base text-gray-900" data-id="element-1424" data-mp="nu8r77zv2ism">
              <strong data-id="element-1425" data-mp="33mpw27pkl6v5">*Disclosure</strong>
            </li>
            <li className="text-base text-gray-900" data-id="element-1426" data-mp="33pc408gdhodw">
              <strong data-id="element-1427" data-mp="38ndl4nu8ndmq">*Fair Housing</strong>
            </li>
            <li className="text-base text-gray-900" data-id="element-1428" data-mp="1qopdw5rejn1x">
              <strong data-id="element-1429" data-mp="1qne7rzahi37n">*General - Deed Fraud, Firewise, AZ Water</strong>
            </li>
            <li className="text-base text-gray-900" data-id="element-1430" data-mp="1lojj4gpu5kfm">
              <strong data-id="element-1431" data-mp="1zpdrizcvvlea">*Legal Issues</strong>
            </li>
            <li className="text-base text-gray-900" data-id="element-1432" data-mp="1zou9lin8gx09">
              <strong data-id="element-1433" data-mp="1vo20qqi9wu4i">
                *Requirements for Licensees (formerly Commissioner's
                Standards/Rules)
              </strong>
            </li>
          </ul>
          <p className="text-base text-gray-900 mb-6" data-id="element-1434" data-mp="17vtrnwrjfnb4">
            <strong className="font-bold" data-id="element-1435" data-mp="130ehbesqo9jg">Elective:</strong> For your remaining
            3 hours you may choose any credit type, providing you do not
            duplicate any course title that you have already taken within the
            renewal period.
          </p>
          <p className="text-base text-gray-900" data-id="element-1436" data-mp="o9p2m2g2kcau">
            Designated, Self-employed Brokers and Associate Brokers with
            Supervisory responsibility are required to take 30 CE credits (every
            2 years) for license renewal (including Broker Management Clinic
            1-3)
          </p>
        </div>

        {/* Timer Notice */}
        <div className="mb-12 bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg" data-id="element-1437" data-mp="jt4hjvh2glsl">
          <div className="flex items-start" data-id="element-1438" data-mp="frsoth2wbkg6">
            <Clock className="w-6 h-6 text-yellow-600 mr-3 mt-1 flex-shrink-0" data-id="element-1439" data-mp="ausqjscaflzm" />
            <div data-id="element-1440" data-mp="5vfvikb9j8ly">
              <p className="text-base text-gray-800 mb-3" data-id="element-1441" data-mp="5vzem4cng31k">
                <strong data-id="element-1442" data-mp="5xiv9w27wg3v">NOTE:</strong> ADRE requires that ALL 3 hr. CE classes,
                either In-Person or Distance Learning, run for a total of 150
                minutes. As required by ADRE, all sections in a class is timed.
                When you begin a section, the timer will begin at 25 minutes. As
                long as your class is open and your browser is connected to the
                server, the timer will continue to count down. If you leave the
                class, your device goes to sleep, click on an outside link, or
                shut off your computer, the timer will stop and will begin again
                where you left off when you log back into the class.
              </p>
              <a href="#" className="inline-flex items-center px-4 py-2 bg-[#fcb53d] text-brand-purple-900 font-bold rounded-md hover:bg-[#e5a436] transition-colors text-sm" data-id="element-1443" data-mp="23rekrbqya7bv">
                CLICK HERE: For sample class
              </a>
            </div>
          </div>
        </div>

        {/* On-Demand Packages Table */}
        <div className="mb-16" data-id="element-1444" data-mp="1fzpojkb0cypn">
          <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-1445" data-mp="1k3nmvssie5hn">
            On-Demand Packages
          </h2>
          <div className="overflow-x-auto" data-id="element-1446" data-mp="1ounmx6wxd3od">
            <table className="w-full border-collapse" data-id="element-1447" data-mp="1ovf43cpryyv4">
              <thead data-id="element-1448" data-mp="scr8gnqsvss9">
                <tr className="bg-gray-700 text-white" data-id="element-1449" data-mp="sbg6mtgx0v3s">
                  <th className="px-4 py-3 text-left text-sm font-bold" data-id="element-1450" data-mp="wdkzhpzjhnpd">
                    Package Name
                  </th>
                  <th className="px-4 py-3 text-center text-sm font-bold" data-id="element-1451" data-mp="1znp0ie76qhy8">
                    Credit Hours
                  </th>
                  <th className="px-4 py-3 text-center text-sm font-bold" data-id="element-1452" data-mp="1updrg5opsbh2">
                    Price
                  </th>
                  <th className="px-4 py-3 text-center text-sm font-bold" data-id="element-1453" data-mp="29gcznfln0y04">
                    Purchase
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-1454" data-mp="1gqec5on3d8xk">
                {packages.map((pkg, index) => <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} data-id="element-1455" data-mp="1brtdvuregzbr" data-mpi={index}>
                    <td className="px-4 py-4 text-sm text-gray-900 border-b border-gray-200" data-id="element-1456" data-mp="1po7xy5n8ck6h">
                      {pkg.name}
                      {pkg.detailsLink && <a href={pkg.detailsLink} className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold ml-2" data-id="element-1457" data-mp="31450wxrwl4mp">
                          Details
                        </a>}
                    </td>
                    <td className="px-4 py-4 text-sm text-gray-900 text-center border-b border-gray-200" data-id="element-1458" data-mp="39kng87luedlo">
                      {pkg.hours}
                    </td>
                    <td className="px-4 py-4 text-sm font-bold text-[#fcb53d] text-center border-b border-gray-200" data-id="element-1459" data-mp="2zpbz5imyouar">
                      {pkg.price}
                    </td>
                    <td className="px-4 py-4 text-center border-b border-gray-200" data-id="element-1460" data-mp="3sdhl28pr4pc6">
                      <button className="px-4 py-2 bg-green-600 text-white font-bold rounded hover:bg-green-700 transition-colors text-xs flex items-center mx-auto" data-id="element-1461" data-mp="3doldecrlxec3">
                        <ShoppingCart className="w-4 h-4 mr-1" data-id="element-1462" data-mp="3ilbt2yzi27wz" />
                        BUY NOW
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        {/* On-Demand Single Classes Table */}
        <div className="mb-12" data-id="element-1463" data-mp="2nd1ht99drchy">
          <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-1464" data-mp="2ifruq09grcxa">
            On-Demand Single Classes
          </h2>
          <div className="overflow-x-auto" data-id="element-1465" data-mp="2di9i9zw8mfkj">
            <table className="w-full border-collapse" data-id="element-1466" data-mp="2dj1glih7yrei">
              <thead data-id="element-1467" data-mp="28j6pbdtj7zsx">
                <tr className="bg-gray-700 text-white" data-id="element-1468" data-mp="28jy9lshoib3w">
                  <th className="px-4 py-3 text-left text-sm font-bold" data-id="element-1469" data-mp="366f83125eur8">
                    Class Name
                  </th>
                  <th className="px-4 py-3 text-center text-sm font-bold" data-id="element-1470" data-mp="3183ucf8qg03q">
                    Credit Type
                  </th>
                  <th className="px-4 py-3 text-center text-sm font-bold" data-id="element-1471" data-mp="2wdzqi4urk86v">
                    Credit Hours
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-bold" data-id="element-1472" data-mp="3owwvcq47oy57">
                    Description
                  </th>
                  <th className="px-4 py-3 text-center text-sm font-bold" data-id="element-1473" data-mp="3k4lt3gm0109h">
                    Price
                  </th>
                  <th className="px-4 py-3 text-center text-sm font-bold" data-id="element-1474" data-mp="3sg3zy1bornar">
                    Purchase
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-1475" data-mp="58jug7vhtw4f">
                {singleClasses.map((cls, index) => <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} data-id="element-1476" data-mp="a97korbwe8xl" data-mpi={index}>
                    <td className="px-4 py-4 text-sm font-semibold text-gray-900 border-b border-gray-200" data-id="element-1477" data-mp="f7ivb4a0ongv">
                      {cls.name}
                    </td>
                    <td className="px-4 py-4 text-sm text-gray-900 text-center border-b border-gray-200" data-id="element-1478" data-mp="o148wkag3yop">
                      {cls.creditType}
                    </td>
                    <td className="px-4 py-4 text-sm text-gray-900 text-center border-b border-gray-200" data-id="element-1479" data-mp="xyio6gkmuhff">
                      {cls.hours}
                    </td>
                    <td className="px-4 py-4 text-sm text-gray-700 border-b border-gray-200" data-id="element-1480" data-mp="12xlm7h273ndw">
                      {cls.description}
                      {cls.moreLink && <a href={cls.moreLink} className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold ml-1" data-id="element-1481" data-mp="8bfwfi4isndc">
                          More &gt;
                        </a>}
                    </td>
                    <td className="px-4 py-4 text-sm font-bold text-[#fcb53d] text-center border-b border-gray-200" data-id="element-1482" data-mp="vxuvd06wj8xr">
                      {cls.price}
                    </td>
                    <td className="px-4 py-4 text-center border-b border-gray-200" data-id="element-1483" data-mp="15wke0v6mgxf2">
                      <button className="px-4 py-2 bg-green-600 text-white font-bold rounded hover:bg-green-700 transition-colors text-xs flex items-center mx-auto" data-id="element-1484" data-mp="10yiru1dwghzd">
                        <ShoppingCart className="w-4 h-4 mr-1" data-id="element-1485" data-mp="32q5fpu2hvwrm" />
                        BUY NOW
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>;
}